if (!window.sizeGuideInitialized) {
  window.sizeGuideInitialized = true;

  const getSizeGuideModal = (id) => {
    // The theme editor can leave stale copies on <body> after a section reload; use the newest.
    const modals = document.querySelectorAll(`[id="${id}"]`);
    return modals[modals.length - 1];
  };

  const getSectionElement = (sectionId) =>
    document.getElementById(`shopify-section-${sectionId}`);

  const getSizeOption = (sectionId) =>
    document.querySelector(
      `variant-selects[data-section="${sectionId}"] [data-size-guide-option]`
    );

  // The Globo Swatch app hides <variant-selects> and renders its own picker.
  const getGloboSizeOption = (sectionId, optionName) => {
    const section = getSectionElement(sectionId);
    if (!section || !optionName) return null;
    const legend = Array.from(
      section.querySelectorAll(".swatch--gl legend.name-option[data-name]")
    ).find(
      (element) =>
        element.dataset.name.trim().toLowerCase() === optionName.toLowerCase()
    );
    return legend ? legend.closest(".swatch--gl") : null;
  };

  const getSelectedSize = (modal) => {
    const globo = getGloboSizeOption(
      modal.dataset.section,
      modal.dataset.sizeOption
    );
    const globoChecked = globo?.querySelector('input[type="radio"]:checked');
    if (globoChecked) return globoChecked.value;

    const option = getSizeOption(modal.dataset.section);
    if (!option) return null;
    const checked = option.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value;
    const select = option.querySelector("select");
    return select ? select.value : null;
  };

  const updateSelectedCard = (modal) => {
    const selected = getSelectedSize(modal);
    modal.querySelectorAll("[data-size-value]").forEach((card) => {
      const isSelected = card.dataset.sizeValue === selected;
      card.classList.toggle("is-selected", isSelected);
      card
        .querySelector("[data-size-guide-select]")
        ?.setAttribute("aria-pressed", isSelected ? "true" : "false");
    });
  };

  const selectSize = (modal, value) => {
    const globo = getGloboSizeOption(
      modal.dataset.section,
      modal.dataset.sizeOption
    );
    const globoInput = globo
      ? Array.from(globo.querySelectorAll('input[type="radio"]')).find(
          (input) => input.value === value
        )
      : null;
    if (globoInput) {
      if (!globoInput.checked) {
        const label = globo.querySelector(`label[for="${globoInput.id}"]`);
        (label || globoInput).click();
      }
      return;
    }

    const option = getSizeOption(modal.dataset.section);
    if (!option) return;
    const radio = Array.from(
      option.querySelectorAll('input[type="radio"]')
    ).find((input) => input.value === value);
    if (radio) {
      if (!radio.checked) radio.click();
      return;
    }
    const select = option.querySelector("select");
    if (select && select.value !== value) {
      select.value = value;
      select.dispatchEvent(new Event("change", { bubbles: true }));
    }
  };

  const createElement = (tag, className, text) => {
    const element = document.createElement(tag);
    element.className = className;
    if (text) element.textContent = text;
    return element;
  };

  // Restyle Globo's size option as bold pills: add a "Choose your size"
  // heading, a check mark inside each pill, and the size guide link after them.
  const enhanceGloboSizeOption = () => {
    document.querySelectorAll("[data-size-guide]").forEach((modal) => {
      const globo = getGloboSizeOption(
        modal.dataset.section,
        modal.dataset.sizeOption
      );
      const values = globo?.querySelector("ul.value");
      if (!values) return;

      if (!globo.classList.contains("size-pills")) {
        globo.classList.add("product-form__input--has-size-guide", "size-pills");
        values.insertAdjacentElement(
          "beforebegin",
          createElement("span", "size-pills__title", "Choose your size")
        );
        const source = getSizeOption(modal.dataset.section)?.querySelector(
          ".size-guide-trigger"
        );
        if (source) values.insertAdjacentElement("afterend", source.cloneNode(true));
      }

      values.querySelectorAll("li[data-value] label").forEach((label) => {
        if (label.querySelector(".size-pills__check")) return;
        label.insertBefore(
          createElement("span", "size-pills__check"),
          label.firstChild
        );
      });
    });
  };

  let injectQueued = false;
  const queueInject = () => {
    if (injectQueued) return;
    injectQueued = true;
    requestAnimationFrame(() => {
      injectQueued = false;
      enhanceGloboSizeOption();
    });
  };

  const startObserving = () => {
    queueInject();
    new MutationObserver(queueInject).observe(document.body, {
      childList: true,
      subtree: true,
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startObserving);
  } else {
    startObserving();
  }

  document.addEventListener("click", (event) => {
    const opener = event.target.closest("[data-size-guide-open]");
    if (opener) {
      const modal = getSizeGuideModal(opener.dataset.sizeGuideOpen);
      if (!modal || typeof modal.show !== "function") return;
      updateSelectedCard(modal);
      modal.show(opener);
      return;
    }

    const selectButton = event.target.closest("[data-size-guide-select]");
    if (selectButton) {
      const modal = selectButton.closest("[data-size-guide]");
      if (!modal) return;
      selectSize(modal, selectButton.dataset.sizeGuideSelect);
      updateSelectedCard(modal);
      setTimeout(() => modal.hide(), 250);
    }
  });
}
